import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Header from './components/header';
import Navbar from './components/navbar';
import Footer from './components/footer';
import AdminDashboard from './components/admin-dashboard';
import CookieConsent from './components/CookieConsent';
import Home from './pages/Home';
import FootballAgency from './pages/FootballAgency';
import About from './pages/About';
import Contact from './pages/Contact';
import Insights from './pages/Insights';
import PlayerDetail from './pages/PlayerDetail';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import FAQ from './pages/FAQ';
import ProjectConsultancy from './pages/ProjectConsultancy';
import MarketResearch from './pages/MarketResearch';
import Advisory from './pages/project-consultancy/Advisory';
import MarketResearchPC from './pages/project-consultancy/MarketResearchPC';
import Planning from './pages/project-consultancy/Planning';
import ICTConsultancy from './pages/project-consultancy/ICTConsultancy';
import Development from './pages/project-consultancy/Development';
import ClientResponsibilities from './pages/project-consultancy/ClientResponsibilities';
import NoGuarantees from './pages/project-consultancy/NoGuarantees';
import Separation from './pages/project-consultancy/Separation';
import Discretion from './pages/project-consultancy/Discretion';
import Members from './pages/Members';
import WorksList from './pages/WorksList';
import WorkDetail from './pages/WorkDetail';
import ServiceDetail from './pages/ServiceDetail';
import WebsiteDevelopment from './pages/WebsiteDevelopment';
import AppDevelopment from './pages/AppDevelopment';
import GraphicDesign from './pages/GraphicDesign';
import { AuthProvider, AuthContext } from './context/AuthContext';

// Protected Route Component
function ProtectedRoute({ children }) {
  const { user, loading } = useContext(AuthContext);
  
  if (loading) return <div>Loading...</div>;
  
  return user ? children : <Navigate to="/" replace />;
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Header />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/football-agency" element={<FootballAgency />} />
          <Route path="/about" element={<About />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/player/:id" element={<PlayerDetail />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/project-consultancy" element={<ProjectConsultancy />} />
          <Route path="/project-consultancy/advisory" element={<Advisory />} />
          <Route path="/project-consultancy/market-research" element={<MarketResearch />} />
          <Route path="/project-consultancy/planning" element={<Planning />} />
          <Route path="/project-consultancy/ict" element={<ICTConsultancy />} />
          <Route path="/project-consultancy/development" element={<Development />} />
          <Route path="/project-consultancy/client-responsibilities" element={<ClientResponsibilities />} />
          <Route path="/project-consultancy/guarantees" element={<NoGuarantees />} />
          <Route path="/project-consultancy/separation" element={<Separation />} />
          <Route path="/project-consultancy/discretion" element={<Discretion />} />
          <Route path="/works/:service" element={<WorksList />} />
          <Route path="/work/:id" element={<WorkDetail />} />
          <Route path="/service/:service" element={<ServiceDetail />} />
          <Route path="/website-development" element={<WebsiteDevelopment />} />
          <Route path="/app-development" element={<AppDevelopment />} />
          <Route path="/graphic-design" element={<GraphicDesign />} />
          <Route path="/market-research" element={<MarketResearch />} />
          <Route path="/members" element={<Members />} />
          <Route
            path="/admin-dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
        <CookieConsent />
        <Footer />
      </Router>
    </AuthProvider>
  );
}

export default App;
